import { NgModule } from '@angular/core';

import { AdminDashboardService }      from './admin-dashboard.service';
import { ChangeAccountingComponent }  from './admin-dashboard.change-accounting.component';
import { SessionManagementComponent } from './admin-dashboard.session-management.component';
import { SharedModule }               from '../shared/shared.module';
import { TableModule }                from '../table/table.module';
import { WsToWsImportComponent }      from './admin-dashboard.ws-to-ws-import.component';

@NgModule({
  declarations: [
    ChangeAccountingComponent,
    SessionManagementComponent,
    WsToWsImportComponent
  ],
  entryComponents: [
    ChangeAccountingComponent,
    SessionManagementComponent,
    WsToWsImportComponent
  ],
  exports: [
    ChangeAccountingComponent,
    SessionManagementComponent,
    WsToWsImportComponent
  ],
  imports: [
    SharedModule,
    TableModule,
  ],
  providers: [
    AdminDashboardService
  ]
})
export class AdminDashboardModule {}
